<template>
    <Icon
        :name="name"
        :width="width"
        :height="height"
        :color="color"
        @click="$emit('click')"
    >
        <path
            class="a"
            d="M21.76,8.253v-6a1.5,1.5,0,0,0-1.5-1.5h-18a1.5,1.5,0,0,0-1.5,1.5v16.5a1.5,1.5,0,0,0,1.5,1.5h6"
        />

        <line class="a" x1="0.76" y1="5.253" x2="21.76" y2="5.253" />

        <circle class="a" cx="13.51" cy="18.003" r="2.25" />

        <circle class="a" cx="21.01" cy="21.003" r="2.25" />

        <circle class="a" cx="21.01" cy="13.503" r="2.25" />

        <line class="a" x1="15.435" y1="16.849" x2="19.085" y2="14.659" />

        <line class="a" x1="15.598" y1="18.839" x2="18.922" y2="20.168" />
    </Icon>
</template>

<script>
import Icon from '@/components/icons/Icon'

export default {
    name: 'WindowSharingIcon',
    components: {
        Icon,
    },
    props: {
        name: {
            type: String,
            default: '',
        },
        width: {
            type: [Number, String],
            default: 24,
        },
        height: {
            type: [Number, String],
            default: 24,
        },
        color: {
            type: String,
            default: '#000',
        },
    },
}
</script>

<style lang="scss" scoped>
.a {
    fill: none;
    stroke: currentColor;
    stroke-linecap: round;
    stroke-linejoin: round;
    stroke-width: 1.5px;
}
</style>
